<div class="text-header"
  [style]="'min-height:'+height+'px'"
  [ngClass]="extended ? 'extended' : ''"
  >
  <app-grid>
    <app-cell [mobile]="$safeNavigationMigration(textColumn?.mobile)"
      [tablet]="$safeNavigationMigration(textColumn?.tablet)"
      [laptop]="$safeNavigationMigration(textColumn?.laptop)"
      [desktop]="$safeNavigationMigration(textColumn?.desktop)"
      >
      <h3 class="serif first-line">{{ firstLine }}</h3>

      <h1 class="second-line">{{ secondLine }}</h1>

      @if (smallText) {
        <p
          class="small-text"
          >
          {{ smallText }}
        </p>
      }
    </app-cell>

    <app-cell [mobile]="$safeNavigationMigration(otherContentColumn?.mobile)"
      [tablet]="$safeNavigationMigration(otherContentColumn?.tablet)"
      [laptop]="$safeNavigationMigration(otherContentColumn?.laptop)"
      [desktop]="$safeNavigationMigration(otherContentColumn?.desktop)"
      >
      <ng-content></ng-content>
    </app-cell>
  </app-grid>
</div>
